export default __webpack_public_path__ + "static/media/a028-example2.b96c4d70.jpg";